import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconFileDownload: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.3975 6.3525L10.8975 1.8525C10.7918 1.74675 10.6493 1.6875 10.5 1.6875H6C4.1865 1.6875 3.1875 2.6865 3.1875 4.5V13.5C3.1875 15.3135 4.1865 16.3125 6 16.3125H12.75C14.5635 16.3125 15.5625 15.3135 15.5625 13.5V6.75C15.5625 6.60075 15.5033 6.4575 15.3975 6.3525ZM11.0625 3.60825L13.6417 6.1875H12.75C11.5673 6.1875 11.0625 5.68275 11.0625 4.5V3.60825ZM12.75 15.1875H6C4.81725 15.1875 4.3125 14.6827 4.3125 13.5V4.5C4.3125 3.31725 4.81725 2.8125 6 2.8125H9.9375V4.5C9.9375 6.3135 10.9365 7.3125 12.75 7.3125H14.4375V13.5C14.4375 14.6827 13.9327 15.1875 12.75 15.1875ZM10.1475 10.8525C10.3673 11.0723 10.3673 11.4285 10.1475 11.6483L8.64752 13.1483C8.59577 13.2 8.53342 13.2412 8.46442 13.2697C8.39542 13.2982 8.32277 13.3133 8.24927 13.3133C8.17577 13.3133 8.10294 13.2982 8.03394 13.2697C7.96494 13.2412 7.90276 13.2 7.85101 13.1483L6.35101 11.6483C6.13126 11.4285 6.13126 11.0723 6.35101 10.8525C6.57076 10.6328 6.92704 10.6328 7.14679 10.8525L7.68677 11.3925V9C7.68677 8.6895 7.93877 8.4375 8.24927 8.4375C8.55977 8.4375 8.81177 8.6895 8.81177 9V11.3917L9.35175 10.8517C9.57225 10.6327 9.92777 10.6328 10.1475 10.8525Z" fill={color} />
  </svg>
);

export default IconFileDownload;
